import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config';

export class BaseResource {
  constructor(
    protected readonly axiosInstance: AxiosInstance,
    protected readonly basePath: string,
    protected readonly configApi: IConfigAPI,
  ) {}
}

// TODO refactor like this
// export class BaseResource {
//   protected readonly basePath: string;
//   constructor(
//     protected readonly axiosInstance: AxiosInstance,
//     protected readonly configApi: IConfigAPI,
//   ) {
//     this.basePath = configApi.usUrl.baseUrl;
//   }
// }
